import { type Prop, prop } from 'lib';
import type { MaybeVNode } from 'lib/view';

import { BoardCtrl } from './board';
import type { DasherData, Mode, PaneCtrl } from './interfaces';
import { LangsCtrl } from './langs';
import { LinksCtrl } from './links';
import { PieceCtrl } from './piece';
import { PingCtrl } from './ping';
import { SoundCtrl } from './sound';
import { ThemeCtrl } from './theme';

const defaultMode: Mode = 'links';

type ModeIndexed = Record<Mode, PaneCtrl>;

export class DasherCtrl implements ModeIndexed {
  ping: PingCtrl;
  langs: LangsCtrl;
  sound: SoundCtrl;
  theme: ThemeCtrl;
  board: BoardCtrl;
  piece: PieceCtrl;
  links: LinksCtrl;

  opts: { playing: boolean; zenable: boolean } = {
    playing: $('body').hasClass('playing'),
    zenable: $('body').hasClass('zenable'),
  };

  constructor(
    readonly data: DasherData,
    readonly redraw: Redraw,
  ) {
    this.ping = new PingCtrl(this);
    this.langs = new LangsCtrl(this);
    this.sound = new SoundCtrl(this);
    this.theme = new ThemeCtrl(this);
    this.board = new BoardCtrl(this);
    this.piece = new PieceCtrl(this);
    this.links = new LinksCtrl(this);
  }

  mode: Prop<Mode> = prop(defaultMode);
  render = (): MaybeVNode => this[this.mode()]?.render() || null;
  setMode = (m: Mode): void => {
    this.mode(m);
    this.redraw();
  };
  close = (): void => this.setMode(defaultMode);
}
